import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { FaTimesCircle } from "react-icons/fa";
import firebaseApp from "../fireconnect";
import { useDropzone } from "react-dropzone";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import { uploadToCloudinary } from "../utils/cloudinary";

const Addproduct = () => {
  const [pname, setpname] = useState("");
  const [pdetails, setdetails] = useState("");
  const [price, setprice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [category, setcategory] = useState("");
  const [image, setImage] = useState([]);
  const [productId, setProductId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadingImages, setUploadingImages] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: async (acceptedFiles) => {
      setUploadingImages(true);
      try {
        for (const file of acceptedFiles) {
          const cloudinaryUrl = await uploadToCloudinary(file);
          setImage((prevImages) => [...prevImages, cloudinaryUrl]);
        }
        toast.success("Images uploaded successfully!");
      } catch (error) {
        console.error("Error uploading images:", error);
        toast.error("Failed to upload images. Please try again.");
      } finally {
        setUploadingImages(false);
      }
    },
    multiple: true,
    accept: { 'image/*': [] },
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state && location.state.productData) {
      const { productData } = location.state;
      setProductId(productData.id);
      setpname(productData.pname);
      setdetails(productData.pdetails);
      setprice(productData.price);
      setDiscountedPrice(productData.discountedPrice);
      setcategory(productData.category);
      setImage(productData.image || []);
    }
  }, [location]);

  const Addproductdata = () => {
    setLoading(true);

    const updatedProduct = {
      pname,
      pdetails,
      price,
      discountedPrice,
      category,
      image,
      id: productId || Date.now(),
      Date: Date(),
    };

    let db = firebaseApp.firestore();

    if (productId) {
      db.collection("Product")
        .where("id", "==", productId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            db.collection("Product")
              .doc(doc.id)
              .update(updatedProduct)
              .then(() => {
                toast.success("Product updated successfully!", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                setLoading(false);
                navigate("/Admin/ProductsTable", {
                  state: { message: "Product updated successfully!" },
                });
              })
              .catch((error) => {
                console.error("Error updating document: ", error);
                setLoading(false);
              });
          });
        });
    } else {
      db.collection("Product")
        .add(updatedProduct)
        .then((docRef) => {
          toast.success("Product added successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setLoading(false);
          navigate("/Admin/ProductsTable", {
            state: { message: "Product added successfully!" },
          });
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
          setLoading(false);
        });
    }

    setpname("");
    setdetails("");
    setprice("");
    setDiscountedPrice("");
    setcategory("");
    setImage([]);
  };

  const removeImage = (img) => {
    const deletedImages = image.filter((item) => item !== img);
    setImage(deletedImages);
  };

  const toolbarOptions = [
    [{ font: [] }, { header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    ["link", "image"],
    [{ color: [] }, { background: [] }],
    ["blockquote", "code-block"],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
  };

  return (
    <>
      <h4 className="mt-1">{productId ? "Edit Product" : "Add Product"}</h4>
      <section className="px-2 pt-2">
        <div className="px-1">
          <div className="form-section row AdminTable rounded-2 pt-3 scrollable-container">
            <div className="form-group col-6">
              <label htmlFor="pname" className="fw-bold">
                Product Name
              </label>
              <input
                type="text"
                className="form-control"
                onChange={(e) => setpname(e.target.value)}
                value={pname}
                required
                id="pname"
              />
            </div>

            <div className="form-group col-6">
              <label htmlFor="category" className="fw-bold">
                Category
              </label>
              <select
                name="Category"
                onChange={(e) => setcategory(e.target.value)}
                value={category}
                className="form-control"
                id="category"
                required
              >
                <option value="">Select</option>
                <option value="Filter">Filter</option>
                <option value="Memorn">Memorn</option>
                <option value="Pump">Pump</option>
                <option value="Geysers">Geysers</option>
              </select>
            </div>

            <div className="form-group col-6">
              <label htmlFor="price" className="fw-bold">
                Product Price
              </label>
              <input
                type="number"
                className="form-control"
                onChange={(e) => setprice(e.target.value)}
                value={price}
                required
                id="price"
              />
            </div>

            <div className="form-group col-6">
              <label htmlFor="discountedPrice" className="fw-bold">
                Discounted Price
              </label>
              <input
                type="number"
                className="form-control"
                onChange={(e) => setDiscountedPrice(e.target.value)}
                value={discountedPrice}
                id="discountedPrice"
                required
              />
            </div>

            <div className="form-group col-12">
              <label htmlFor="pdetails" className="fw-bold">
                Product Details
              </label>
              <ReactQuill
                value={pdetails}
                onChange={setdetails}
                theme="snow"
                placeholder="Enter product details"
                id="pdetails"
                modules={modules}
                required
              />
            </div>

            <div className="form-group col-12">
              <label className="fw-bold">Images</label>
              <div
                {...getRootProps({ className: "dropzone" })}
                className="dropzone"
                style={{ opacity: uploadingImages ? 0.6 : 1 }}
              >
                <input {...getInputProps()} />
                {uploadingImages ? (
                  <p>Uploading images to cloud... Please wait</p>
                ) : (
                  <p>Drag and drop images here, or click to select files</p>
                )}
              </div>

              {image.length > 0 && (
                <div className="row mt-3">
                  {image.map((i, index) => (
                    <div key={index} className="col-2">
                      <div className="d-flex justify-content-between">
                        <img
                          className="img-fluid m-0 w-100"
                          alt="img"
                          src={i}
                        />
                        <Button
                          onClick={() => removeImage(i)}
                          style={{
                            padding: "0",
                            width: "25px",
                            height: "25px",
                            marginLeft: "0px",
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        >
                          <FaTimesCircle
                            style={{
                              color: "#ff0000",
                              fontSize: "20px",
                            }}
                          />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="form-group">
              <Button
                onClick={Addproductdata}
                variant="dark"
                className="submit-btn"
                disabled={loading || uploadingImages}
              >
                {loading
                  ? productId
                    ? "Updating..."
                    : "Saving..."
                  : productId
                    ? "Update Product"
                    : "Add Product"}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
};

export default Addproduct;
